module.exports = __webpack_public_path__ + "img/Research.e900d226.svg";